var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.navShow)?_c('header_index'):_vm._e(),(_vm.isRouterAlive)?_c('router-view'):_vm._e(),(_vm.$route.meta.navShow)?_c('footer_index'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }